import React, { memo } from 'react';
import { Link } from 'gatsby';
import { Grid, Chip, Box, useTheme } from '@mui/material';

import Markdown from './Markdown';
import RelatedPosts from './RelatedPosts';
import PostHeader from './PostHeader';
import Languages from './Languages';
import { Post } from 'src/models/fragments';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

interface Props {
  post: Post;
  viewCount?: number;
  otherLangPosts: Array<Pick<Post, 'fields'>>;
}
const PostContents = ({ post, viewCount, otherLangPosts }: Props) => {
  const { spacing, shape } = useTheme();
  const { frontmatter, html } = post;

  const title = frontmatter?.title ?? '';
  const subTitle = frontmatter?.subTitle ?? '';
  const date = frontmatter?.date ?? '';
  const tags = frontmatter?.tags ?? [];

  const thumbnail = frontmatter?.jumbotron?.childImageSharp;

  return (
    <>
      <PostHeader title={title} subTitle={subTitle} date={date} viewCount={viewCount} />
      {thumbnail && (
        <Box sx={{ marginTop: spacing(6), borderRadius: shape.borderRadius, overflow: 'hidden' }}>
          <GatsbyImage image={getImage(thumbnail)!} alt={title} title={title} />
        </Box>
      )}
      {otherLangPosts.length > 0 && (
        <Box sx={{ marginTop: spacing(6) }}>
          <Languages otherLangPosts={otherLangPosts} />
        </Box>
      )}
      <Markdown html={html ?? ''} />
      <Box component="section" sx={{ marginTop: spacing(4) }}>
        <RelatedPosts tags={tags ?? []} currentPost={post} />
      </Box>
    </>
  );
};

export default memo(PostContents);
